export enum RequestState {
	IDLE,
	Requested,
	Received,
}

export enum ButtonType {
	Disabled,
	Saving,
	Saved,
	Enabled,
}

export enum EventStatus {
	Scheduled = "scheduled",
	Active = "playing",
	Complete = "complete",
}

export enum SectionType {
	LEAGUE = "league",
	GENERAL = "general",
}

export enum ShareNet {
	Facebook = "fb",
	Twitter = "tw",
	Native = "native",
}

export enum ShareSource {
	General = "general",
	Prediction = "prediction",
}

export enum ActiveStep {
	PREDICTION,
	SUMMARY,
}

export enum Language {
	English = "en",
	French = "fr",
}

export enum LanguageType {
	EN = "en",
	FR = "fr",
}

export enum IsFriendly {
	YES = "f",
	NO = "n",
}

export enum LinksType {
	FIRST,
	SECOND,
	WITH_IMAGE,
	EMPTY,
}
